import SchedulerPrintOut from './scheduler-printout.component'

export default SchedulerPrintOut
